/** The app's frame (the menu, its rows, the top bar), the screens the menu opens, and Find's When chips. */
export const shell = {
    "nav.talk": "Talk",
    "nav.activity": "Activity",
    "nav.records": "Records",
    "nav.about": "About me",
    "nav.privacy": "Privacy",
    "nav.settings": "Settings",
    "a11y.back": "Back",
    "shell.menu": "Menu",
    "shell.drawer": "GigSync menu",
    "shell.close_menu": "Close menu",
    "shell.to_chat": "Back to chat",
    "shell.need_you.one": "{count} needs you",
    "shell.need_you.other": "{count} need you",
    "shell.model_about": "What runs your agent. Tap for Settings.",
    "shell.model_device": "On this phone",
    "shell.model_lite": "Lite mode",
    "shell.model_server": "GigSync's model",
    "shell.model_ollama": "Ollama · {name}",
    "shell.edit_card": "Edit my card",
    "profile.card_off": "Your card is not on the board",
    "profile.language": "Language",
    "when.today": "Today",
    "when.tomorrow": "Tomorrow",
    "when.pick": "Pick a date",
    "when.daily": "Every day",
    "perm.mic_why": "To hear you, GigSync needs the microphone. Your phone will ask you next.",
    "perm.continue": "Continue",
    "perm.not_now": "Not now",
};
//# sourceMappingURL=shell.js.map